import React from 'react';
import CTA from '@/components/shared/CTA';

interface LogoProps {
    id: string;
}
const Logo: React.FC<LogoProps> = ( { id = '' } )=> {
    return (
        <CTA classes={ [ 'lm-logo' ] } url={ window.homeURL + '/' } id={ id }><span>{ 'Live Mobile Now' }</span></CTA>
    )
}
export default Logo;